export default "__VITE_ASSET__B4NxorUY__"